import { render, staticRenderFns } from "./vHero.vue?vue&type=template&id=350f24a4&scoped=true&"
import script from "./vHero.vue?vue&type=script&lang=js&"
export * from "./vHero.vue?vue&type=script&lang=js&"
import style0 from "./vHero.vue?vue&type=style&index=0&id=350f24a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350f24a4",
  null
  
)

/* custom blocks */
import block0 from "./vHero.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports